<template>
  <div id="home">
  <!-- <div id="home" style="background-image: linear-gradient(to top, #fff1eb 0%, #ace0f9 100%);"> -->
  <!-- <div id="home" style="background:white"> -->
    <md-toolbar id="toolbar" class="md-dense" style="padding-right:0px;color:black; ">
      <md-avatar >
        <img src="/static/SlinkTextLogo96.png" alt="Slink Logo">
      </md-avatar>
      <!-- <h1 class="md-title" style="flex: 1; text-align:left; font-family: Pacifico; font-size:25px;padding-left:5px">Slink</h1> -->
      <h1 class="md-title" style="flex: 1; text-align:left; font-size:25px;padding-left:5px"></h1>
      <div v-if="country !== 'IN'" style="display:inline-flex; gap:10px; padding:8px;">
      <md-button id="loginMenu" @click="openDialog('loginDialog'); gGALog('Home','CTA', 'Login Button - Toolbar')" class="toolbarButtons md-raised md-dense" style="margin:unset; min-width: unset; border-radius: 8px; padding-left: 12px; padding-right: 12px;">Log In
      </md-button>
      <md-button id="signupMenu" @click="openDialog('signupDialog'); gGALog('Home','CTA', 'SignUp Button - Toolbar')" class="toolbarButtons md-raised md-dense" style="margin:unset; min-width: unset; border-radius: 8px; padding-left: 12px; padding-right: 12px;">Sign Up
      </md-button>
    </div>
    </md-toolbar>

    <md-dialog class="fullScreenDialog" ref="loginDialog" :md-click-outside-to-close="false" v-if="country !== 'IN'">
      <md-dialog-title style="text-align:center">Welcome back!</md-dialog-title>

      
      <!-- <form v-on:submit.prevent="loginByEmail()" style="width:100%"> -->
        <md-dialog-content style="width: 100%;">
        <!-- <md-dialog-content style="width: 100%; background-image: url(/static/images/admin/undraw_mobile_login_ikmv.svg); background-position: bottom; background-size: contain; background-repeat: no-repeat;} -->

<!-- "> -->
          <md-layout>
        <md-layout md-hide-small md-hide-medium md-flex-large="33">
        </md-layout>
        <md-layout md-flex-small="100" md-flex-medium="100" md-flex-large="33">
          <!-- <p style="width:100%; text-align:center; font-weight:bold"></p> -->
            
          
          
          <div class="slinkContainer" style="padding:15px; padding-bottom: 0px;border-radius: 10px;">
            <p style="width:100%; text-align:center;font-size: 14px;">LOG IN WITH EMAIL</p>
            <md-input-container style="margin-bottom: 5px;">
              <label>Email</label>
              <md-input v-model="loginEmail" autocomplete="username" name="loginEmail" required ></md-input>
            </md-input-container>
            <md-input-container md-has-password style="margin-bottom: 10px;">
              <label>Password</label>
              <md-input type="password" autocomplete="current-password" v-model="loginPassword" required></md-input>
            </md-input-container>
           <div>
           <!-- <md-button class="md-primary rounded10" @click="closeDialog('loginDialog')">Cancel</md-button> -->
          <!-- <md-button :disabled="!(loginEmail && loginPassword)" class="md-accent" type="submit">Login</md-button> -->
          <md-button :disabled="!(loginEmail && loginPassword)" class="md-accent md-raised rounded5" style="margin:10px 0; width:100%" @click="loginByEmail()">Login</md-button>

          </div>
          <md-button class="md-dense md-primary rounded10" style="width:100%;margin:unset; text-transform:unset" @click="forgotPassword(loginEmail)">Forgot your password?</md-button>

          </div>

          <p style="width:100%; text-align:center;margin:10px">OR</p>

          <md-button @click="loginByGoogle()" class="md-raised googleBtn" style="width:100%; border-radius: 10px;"><img src="/static/images/home/googleg_color.png" style="font-size:16px;width:24px;margin-right:10px;margin-top:10px;margin-bottom:10px;" />Log In with Google</md-button>



          <!-- <div style="display: flex; width: calc(100% - 48px); justify-content: center; position: absolute; bottom: 5px;"><img src="/static/images/admin/undraw_mobile_login_ikmv.svg" alt="People" style="max-height:200px;padding:5px;"></div> -->
          </md-layout>
          <md-layout md-hide-small md-hide-medium md-flex-large="33">
          </md-layout>
        </md-layout>
       
        </md-dialog-content>
        <!-- <md-dialog-actions>
          
                        <span style="flex: 1"></span>

          <md-button class="md-primary" @click="closeDialog('loginDialog')">Cancel</md-button>
          <md-button :disabled="!(loginEmail && loginPassword)" class="md-accent" @click="loginByEmail()">Login</md-button>
          
        </md-dialog-actions> -->
      <!-- </form> -->
          
    </md-dialog>

      <md-dialog class="fullScreenDialog" ref="signupDialog">
        <md-dialog-title style="text-align:center;font-weight:bold">Sign Up
          <!-- <br>Create an account to start using Slink -->
          </md-dialog-title>
        
        <!-- <form v-on:submit.prevent="signupByEmail()" style="width:100%"> -->
          <md-dialog-content v-if="country !== 'IN'">
            <md-layout>
        <md-layout md-hide-small md-hide-medium md-flex-large="33">
        </md-layout>
        <md-layout md-flex-small="100" md-flex-medium="100" md-flex-large="33">
<div class="slinkContainer" style="padding:15px; border-radius:10px">
            <p style="width:100%; text-align:center;font-size: 14px;">SIGN UP WITH EMAIL</p>
            <md-input-container style="margin-bottom: 5px;">
              <label>Email</label>
              <md-input style="font-size:18px !important" v-model="signupEmail" autocomplete="email" required></md-input>
            </md-input-container>
            <md-input-container md-has-password style="margin-bottom: 5px;">
              <label>Password</label>
              <md-input type="password" v-model="signupPassword" autocomplete="new-password" required></md-input>
            </md-input-container>
            <!-- <p STYLE="font-size:smaller">By signing up to Slink you will be added to our mailing list.</p> -->

            <div>
          <!-- <md-button class="md-primary rounded10" @click="closeDialog('signupDialog')">Cancel</md-button> -->
            <md-button :disabled="!(signupEmail && signupPassword)" class="md-raised rounded5" @click="signupByEmail()" style="width:100%;margin:10px 0 0px 0">Sign Up</md-button>

          </div>
            </div>
            <p style="width:100%; text-align:center;margin:10px">OR</p>
            <md-button @click="loginByGoogle()" class="md-raised googleBtn" style="width:100%; border-radius:10px"><img src="/static/images/home/googleg_color.png" style="font-size:16px;width:24px;margin-right:10px;margin-top:10px;margin-bottom:10px" />Sign Up with Google</md-button>

            <p STYLE="font-size:smaller; text-align:center;margin-top:30px;width:100%">The sign up process will add you to our mailing list.</p>


            </md-layout>
        <md-layout md-hide-small md-hide-medium md-flex-large="33">
        </md-layout>
      </md-layout>
          </md-dialog-content>
        <md-dialog-content v-else>
          We are no longer accepting sign-ups from this region.
          </md-dialog-content>
          <!-- <md-dialog-actions>
            <md-button class="md-primary" @click="closeDialog('signupDialog')">Cancel</md-button>
            <md-button :disabled="!(signupEmail && signupPassword)" class="md-accent" @click="signupByEmail()">Sign Up</md-button>
          </md-dialog-actions> -->
        <!-- </form> -->
        
      </md-dialog>
      
      


      <!-- 
Dev by: Lihex Andrade 27/07/2020
-->
<div v-if="isDev" class="slider">
<ul>
  <li>
      <div class="phone">
        
        <img src="https://i.ibb.co/R4Mj2kT/jT.jpg" alt="">
      </div>
    </li>
    <li>
      <div class="phone">
        <img src="https://i.ibb.co/WFP9dvc/gK.jpg" alt="">
      </div>
    </li>
    <li>
      <div class="phone">
        <img src="https://i.ibb.co/W5j0nSL/bS.jpg" alt="">
      </div>
    </li>
    <li>
      <div class="phone">
        <img src="https://i.ibb.co/cbS52z7/rjb.jpg" alt="">
      </div>
    </li>
    <li>
      <div class="phone">
        <img src="https://i.ibb.co/pRcRhWh/cW.jpg" alt="">
      </div>
    </li>
    <!-- <li>
        <img src="https://via.placeholder.com/200?text=Logo%205" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%206" alt="">
    </li> -->
    <!-- <li>
        <img src="https://via.placeholder.com/200?text=Logo%207" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%208" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%209" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2010" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2011" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2012" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2013" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2014" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2015" alt="">
    </li> -->
</ul>
<ul>
    <li>
      <div class="phone">
        
        <img src="https://i.ibb.co/R4Mj2kT/jT.jpg" alt="">
      </div>
    </li>
    <li>
      <div class="phone">
        <img src="https://i.ibb.co/WFP9dvc/gK.jpg" alt="">
      </div>
    </li>
    <li>
      <div class="phone">
        <img src="https://i.ibb.co/W5j0nSL/bS.jpg" alt="">
      </div>
    </li>
    <li>
      <div class="phone">
        <img src="https://i.ibb.co/cbS52z7/rjb.jpg" alt="">
      </div>
    </li>
    <li>
      <div class="phone">
        <img src="https://i.ibb.co/pRcRhWh/cW.jpg" alt="">
      </div>
    </li>
    <!-- <li>
        <img src="https://via.placeholder.com/200?text=Logo%205" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%206" alt="">
    </li> -->
    <!-- <li>
        <img src="https://via.placeholder.com/200?text=Logo%207" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%208" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%209" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2010" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2011" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2012" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2013" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2014" alt="">
    </li>
    <li>
        <img src="https://via.placeholder.com/200?text=Logo%2015" alt="">
    </li> -->
</ul>
</div>





      <md-layout style="margin-top:5vh;">
        <!-- DESKTOP -->
        <md-layout md-hide-xsmall md-hide-small md-flex-medium="20" md-flex-large="20" md-flex-xlarge="20" style="background:white" />
        <md-layout md-hide-xsmall md-hide-small md-flex-medium="30" md-flex-large="30" md-flex-xlarge="30" md-align="end" style="padding-top:10vh">
          <div style="text-align:left;padding-left: 35px; font-size: 3.5vw; font-weight:bolder; line-height: 1.1;;margin-bottom: 0px;; width:100%">
            Slink: Your digital<br>business card.
          </div> 
          <div style="text-align:left;padding: 25px 0px 0px 35px;width:100%; height:100%;font-size:20px; line-height:1.2">
            All your social media, streaming, ecommerce & websites links in one place.
            <p style="font-size:20px; line-height:1.2">One link you share everywhere.</p>          
            <md-button class="md-raised md-warn signupBtn" @click="openDialog('signupDialog'); gGALog('Home','CTA', ' SignUp Button - Intro')">Sign Up for Free</md-button>
          </div>
        </md-layout>

        <!-- PHONE DEMO -->
        
        <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="30" md-flex-large="30" md-flex-xlarge="30" md-align="center" style=" background-image: url('/static/images/home/splash.png');background-size:contain;background-repeat: no-repeat,no-repeat;background-position: center; margin-left: auto;margin-right: auto;">
          <div class="phone" style="width: calc(160px + 5vw); border-radius: 20px; padding: 7px; box-shadow: 0 50px 100px -20px rgb(50 50 93 / 25%), 0 30px 60px -30px rgb(0 0 0 / 30%), inset 0 -2px 6px 0 rgb(10 37 64 / 35%); background: #f6f9fc;">
          <!-- <div class="phone" style="transform-style: preserve-3d;transform: perspective(1000px) rotateX(4deg) rotateY(-16deg) rotateZ(4deg); width: calc(160px + 5vw); border-radius: 20px; padding: 7px; box-shadow: 0 50px 100px -20px rgb(50 50 93 / 25%), 0 30px 60px -30px rgb(0 0 0 / 30%), inset 0 -2px 6px 0 rgb(10 37 64 / 35%); background: #f6f9fc;"> -->
          <!-- <div style="box-shadow: skyblue 0px 12px 30px -10px; width:calc(160px + 5vw); border-radius:20px; border-style:solid; border-color:silver; border-width:5px;border-bottom-width: 15px; border-top-width: 10px; background: silver;"> -->
            <div class="fling-minislide" id="frame">
              <img src="https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/aokmusic_qj_8uWh2I.png" id="scrn1" style="width:100%;object-fit: unset">
              <img src="https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/mttradingbot_jqfrmpQcj.png" id="scrn1" style="width:100%;object-fit: unset">
              <img src="https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/misssperu_S5Ul4TyKr.png" id="scrn1" style="width:100%;object-fit: unset">
              <!-- <img src="/static/images/home/rosanna.jpg" id="scrn1" style="object-fit: unset"> -->
              <img src="https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/emtfilms_C-1nJmS-Ra.png" style="width:100%;object-fit: unset">
              <img src="https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/goub_Ju25naL7M.png" style="width:100%;object-fit: unset">
              <!-- <img src="https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/eugenezeelie8_16Tzl4EY6.png" style="width:100%;object-fit: unset"> -->

              <img src="https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/modenaautomotive_sa_pWvJxHd.png" style="width:100%;object-fit: unset">
              <!-- <img src="/static/images/home/misssperu.png" style="object-fit: unset"> -->
              <!-- <img src="/static/images/home/modena.jpg" style="object-fit: unset"> -->
            </div>
            
            
          </div>
        </md-layout>
        <md-layout md-hide-xsmall md-hide-small md-flex-medium="20" md-flex-large="20" md-flex-xlarge="20" style="background:white" />

        <!-- MOBILE -->
        <md-layout md-flex-xsmall="100" md-flex-small="100" md-hide-medium-and-up style="">
          <div style="text-align:center;padding: 20px; font-size: 2.5rem; font-weight:bolder; line-height: 1.1;font-family:unset;;margin-bottom: 0px;; width:100%;">
            Slink: Your digital business card.
          </div> 
          <div style="padding: 0px 25px;width:100%; height:100%;font-size:16px; line-height:1.4">
            All your social media, streaming, ecommerce & websites links in one place.
            <p style="font-size:16px; line-height:1.4">One link you share everywhere.</p>          
            <md-button class="md-raised md-warn signupBtn" @click="openDialog('signupDialog'); gGALog('Home','CTA', ' SignUp Button - Intro')">Sign Up for Free</md-button>
          </div>
        </md-layout>
      </md-layout>
<div style="margin:20px">
        <h2>HOW IT WORKS</h2> 

      <div>
      <div class="driftvideo" style="position:relative; overflow:hidden; margin-left:auto; margin-right:auto;border-radius:15px; box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12); max-width:475px">
        <iframe id="ytplayer" type="text/html" width="720" height="405"
src="https://www.youtube.com/embed/aCRH1v7qxAQ?fs=0&loop=1&modestbranding=1&playsinline=1&start=4&color=white"
frameborder="0" allowfullscreen style="min-height:200px"/>
<!--        
        <a href="https://video.drift.com/v/abTpp0Zo0L7/" target="_blank">
          <img src="https://public-media.driftvideo.com/video-thumbnails/HYFY-THUMBNAIL-1336743-1384494-1590052261108-ss-5.jpeg">
         
        <md-icon class="md-size-3x" style="    position: absolute;
    left: calc(50vw - 36px);
    padding-top: 90px;color:white;opacity: 0.75;">play_circle_outline</md-icon></a> -->
        <p style="margin:10px">Slink User - Eddie Melendez aka "EMT" is the creator of EMT Films, he explains how Slink and the Slink Card works.
          </p>
      </div>
      <!-- <div class="productsContainer">
        <a class="product" href="https://store.getsl.ink/Slink-Card-p212427704" target="_blank">
          <figure>
            <img src="https://d2j6dbq0eux0bg.cloudfront.net/images/27522101/1496569594.jpg">
            <figcaption><b>Slink Card</b><br>£15</figcaption>
          </figure>
        </a>

        <a class="product" href="https://store.getsl.ink/Slink-Stickers-p213701654" target="_blank">
          <figure>
            <img src="https://d2j6dbq0eux0bg.cloudfront.net/images/27522101/1723470416.jpg">
            <figcaption><b>Slink Stickers</b><br>£7</figcaption>
          </figure>
        </a>

      </div> -->
      </div>

            <md-button class="md-raised md-warn signupBtn" @click="openDialog('signupDialog'); gGALog('Home','CTA', ' SignUp Button - Intro')">Sign Up for Free</md-button>

</div>



 <div style="margin:20px">
        <h2>WHY SLINK?</h2> 
        <md-layout>
          <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
            <!-- <img src="/static/images/home/why_grow_audience.png" /> -->
            <md-card style="border-radius: 15px; margin:10px; width:100%">
  <md-card-media>
    <img src="/static/images/admin/grow.svg" alt="People" style="max-height:200px;padding:0px;">
    
  </md-card-media>

  <md-card-header style="padding-top:revert">
    <div class="md-title">Grow your audience!</div>
  </md-card-header>
<md-card-content>
    Add links to any social media platform, website, e-commerce store.. anywhere!
  </md-card-content>
</md-card>
          </md-layout>
          <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">

                       <!-- <img src="/static/images/home/why_monestise.png" /> -->

<md-card style="border-radius: 15px; margin:10px; width:100%">
  <md-card-media>
    <img src="/static/images/admin/monetise.svg" alt="People" style="max-height:200px;padding:0px;">
  </md-card-media>

  <md-card-header style="padding-top:revert">
    <div class="md-title">Monetise your platforms!</div>
  </md-card-header>
<md-card-content>
    Add payment links, products, subscriptions....
  </md-card-content>
</md-card>
          </md-layout>
          <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
             <!-- <img src="/static/images/home/why_audio_video_content.png" /> -->
<md-card style="border-radius: 15px; margin:10px; width:100%">
  <md-card-media>
    <img src="/static/images/admin/media.svg" alt="People" style="max-height:200px;padding:0px;">
  </md-card-media>

  <md-card-header style="padding-top:revert">
    <div class="md-title">Release audio & video content!</div>
  </md-card-header>
<md-card-content>
    Promote new songs, new YouTube videos even stream your games live!
  </md-card-content>
</md-card>
          </md-layout>
        </md-layout>
        <md-layout>
          <md-layout md-flex-xsmall="0" md-flex-small="0" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
          </md-layout>
          <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
        <md-button class="md-raised md-warn signupBtn" style="width:190.35px;margin-left:auto; margin-right:auto; margin-top:20px" @click="openDialog('signupDialog'); gGALog('Home','CTA', ' SignUp Button - Steps')">Sign Up for free</md-button>

          </md-layout>
          <md-layout md-flex-xsmall="0" md-flex-small="0" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
          </md-layout>
        </md-layout>
      </div>






      <div style="margin:20px">
        <h2>WHAT NEXT?</h2> 
        <md-layout>
          <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">

            <md-card style="border-radius: 15px; margin:10px; width:100%">
  <md-card-media>
    <img src="/static/images/admin/register.svg" alt="People" style="max-height:200px;padding:0px;">
  </md-card-media>

  <md-card-header style="padding-top:revert">
    <div class="md-title">1. Sign up for FREE</div>
  </md-card-header>
<md-card-content>
    Pick your own unique Slink address.<br>Love it, cherish it, share it!
  </md-card-content>
</md-card>


          </md-layout>
          <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">

            <md-card style="border-radius: 15px; margin:10px; width:100%">
  <md-card-media>
    <img src="/static/images/admin/build.svg" alt="People" style="max-height:200px;padding:0px;">
  </md-card-media>

  <md-card-header style="padding-top:revert">
    <div class="md-title">2. Build your page</div>
  </md-card-header>
<md-card-content>
    Add your social media, streaming links,<br>website and content to your page
  </md-card-content>
</md-card>

          </md-layout>
          <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
             <md-card style="border-radius: 15px; margin:10px; width:100%">
  <md-card-media>
    <img src="/static/images/admin/sharepage.svg" alt="People" style="max-height:200px;padding:0px;">
  </md-card-media>

  <md-card-header style="padding-top:revert">
    <div class="md-title">3. Share it everywhere</div>
  </md-card-header>
<md-card-content>
    Share your Slink URL everywhere,<br>Instagram, Twitter, Snapchat, Email, anywhere!
  </md-card-content>
</md-card>

          </md-layout>
        </md-layout>
        <md-layout>
          <md-layout md-flex-xsmall="0" md-flex-small="0" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
          </md-layout>
          <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
        <md-button class="md-raised md-warn signupBtn" style="width:190.35px;margin-left:auto; margin-right:auto; margin-top:20px" @click="openDialog('signupDialog'); gGALog('Home','CTA', ' SignUp Button - Steps')">Sign Up for free</md-button>

          </md-layout>
          <md-layout md-flex-xsmall="0" md-flex-small="0" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
          </md-layout>
        </md-layout>
      </div>

      <div>
        <md-layout>
          <md-layout md-hide-xsmall md-hide-small md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33"></md-layout>
            <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
              <div style="text-align:center; width:100%">
                <center>
                  <h2>HAPPY SLINKERS</h2> 
                  <h3 style="margin:unset">Who  uses Slink?</h3>
                  <ul class="happySlinkersUL">
                    <li style="margin-left:25px; margin-right:25px"><strong>Model, Bloggers & Influencers</strong> - add your social media links, blog/vlog links and even your online stores such as Depop, etc</li>
                    <li style="margin-left:25px; margin-right:25px"><strong>Singers & Artists</strong> - promote your music on all platforms, stream audio and video from the likes of Spotify and YouTube</li>
                  </ul>
                </center>
              </div>
            

              <md-boards :md-auto="true" :md-infinite="true" :md-controls="false" :md-duration="10000" :md-swipeable="true">
               <md-board id="review000">
                <div class="testimonial">
                  <img src="/static/images/home/jaybrave.jpg" />
                  <div class="content">
                    <div class="review">
                      Gone are the days of me forwarding random links from different sites which no one ever ends up looking at - Slink changes everything!
                    </div>
                    <div class="name">
                      Jay Brave
                    </div>
                  </div>
                </div>
               </md-board>

               <md-board id="review001">
                <div class="testimonial">
                  <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fingmarwein.jfif?alt=media&token=7f1914dd-d9a0-4814-95aa-4c4d0ab9cebb" />
                  <div class="content">
                    <div class="review">
                       Been using Slink to promote all my social media and blog/website links for a while now, and I love their service! 👌👌
                    </div>
                    <div class="name">
                      Ingmar Wein
                    </div>
                  </div>
                </div>
               </md-board>
              
              <md-board id="review002">
                <div class="testimonial">
                  <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fjoeybase.jpg?alt=media&token=18edeb57-3c21-4306-993f-6dc5b1f08770" />
                  <div class="content">
                    <div class="review">
                      Before Slink I struggled to promote all my music at the same time.
                    </div>
                    <div class="name">
                      Joey Base
                    </div>
                  </div>
                </div>
              </md-board>

              <md-board id="review003">
                <div class="testimonial">
                  <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fshaewise.jpg?alt=media&token=4f497919-21f9-4de5-8cbf-29bf687e3354" />
                  <div class="content">
                    <div class="review">
                      Very helpful marketing app, especially for influencers like myself. I love the easy to use UI and the versatility of the home page.
                    </div>
                    <div class="name">
                      Shae Vena
                    </div>
                  </div>
                </div>
              </md-board>

              <md-board id="review004">
                <div class="testimonial">
                  <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fdanidaizee.jpg?alt=media&token=4fc1b7b8-2478-4d12-b3a3-6d20d2094ccd" />
                  <div class="content">
                    <div class="review">
                      Can’t recommend Slink enough. They go above & beyond always. From customer services to generally just making life a lot easier.
                    </div>
                    <div class="name">
                      Dani Daizee
                    </div>
                  </div>
                </div>
              </md-board>  

              <md-board id="review005">
              <div class="testimonial">
                <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fvince.jpg?alt=media&token=776b358e-baa3-40a3-bfc8-d5e874a44883" />
                <div class="content">
                  <div class="review">
                      Fantastic team, great response. Always happy with the service they provide
                  </div>
                  <div class="name">
                    Vincent Azzopardi
                  </div>
                </div>
              </div>
              </md-board>

              <md-board id="review006">
              <div class="testimonial">
                <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fvicky.jpg?alt=media&token=80ef2dee-e93f-46e5-86a2-8827a8f45bd8" />
                <div class="content">
                  <div class="review">
                      Love this, use it for business and always recommend as it’s so easy to share when out and about and really handy when networking online.
                  </div>
                  <div class="name">
                    Vicky Cunningham
                  </div>
                </div>
              </div>
              </md-board>

              <md-board id="review007">
              <div class="testimonial">
                <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fworthington.jpg?alt=media&token=d0d3141e-f7bc-4a1f-acf2-ad6c7eb57b7b" />
                <div class="content">
                  <div class="review">
                      The slink card is very handy when I'm out of business cards or in this pandemic situation where I don't want to hand someone something physical.
                  </div>
                  <div class="name">
                    Gareth Worthington
                  </div>
                </div>
              </div>
              </md-board>

              <md-board id="review008">
              <div class="testimonial">
                <img src="https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Frheo.jpg?alt=media&token=2139943c-75c5-44d0-8dff-ea327be4ce0e" />
                <div class="content">
                  <div class="review">
                      It is vital for me to get my social media links to the right people accurately and quickly, there is no better way to achieve this other than using Slink! Simple, effective, stylish!
                  </div>
                  <div class="name">
                    Rheo
                  </div>
                </div>
              </div>
              </md-board>

               


                </md-boards>
          </md-layout>
          <md-layout md-hide-xsmall md-hide-small md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33"></md-layout>
        </md-layout>
    <div style="padding:20px">
      <h2>Are you ready to become a social media superhero?</h2> 

      <IconCloud :items="logos" :options="{ radius: 250, maxSpeed: 'fast', keep: true }" />
        <md-layout>
          <md-layout md-hide-xsmall md-hide-small md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33"></md-layout>
            <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33">
            <md-button class="md-raised md-warn signupBtn" style="width:190.35px;margin-left:auto; margin-right:auto; margin-top:20px" @click="openDialog('signupDialog'); gGALog('Home','CTA', ' SignUp Button - Superhero')">Sign Up for free</md-button>
          </md-layout>
          <md-layout md-hide-xsmall md-hide-small md-flex-medium="33" md-flex-large="33" md-flex-xlarge="33"></md-layout>
        </md-layout>
        <div style="padding-top:40px;font-size:small">
          <md-button style="color:#3b5998" href="https://www.facebook.com/getslink/" target="_blank" class="md-icon-button">
            <md-icon md-iconset="fa fa-facebook" style="font-size:medium"></md-icon>
          </md-button>
          <md-button style="color:#e1306c" href="https://www.instagram.com/slinkapp" target="_blank" class="md-icon-button">
            <md-icon md-iconset="fa fa-instagram" style="font-size:medium"></md-icon>
          </md-button>
          <md-button style="color:#1da1f2" href="https://www.twitter.com/slink_app" target="_blank" class="md-icon-button">
            <md-icon md-iconset="fa fa-twitter" style="font-size:medium"></md-icon>
          </md-button>
          <md-button style=" -webkit-text-fill-color: white;  -webkit-text-stroke-width: 1px;  -webkit-text-stroke-color: black; " href="https://www.snapchat.com/add/slinkapp" target="_blank" class="md-icon-button">
            <md-icon md-iconset="fa fa-snapchat-ghost" style="font-size:medium"></md-icon>
          </md-button>

        </div>
        <div style="margin-top:50px; text-transform:uppercase; font-size:smaller">Made with ❤️ in London</div>
      </div>
    </div>
    <md-snackbar ref="snackbar" :md-duration="4200">
      <span>{{ notification }}</span>
      <md-button class="" @click="$refs.snackbar.close()">OK</md-button>
    </md-snackbar>
      <md-button class="md-fab md-mini" 
        style="z-index: 99; padding:0; min-width:unset; position: fixed; right: 10px; bottom: 10px;" 
      @click="openExternal('https://tawk.to/chat/67b85c0ac3759e190c7859b5/1ikk2f2n9')"><md-icon>help_outline</md-icon></md-button>
  </div>
</template>

<script>
import Firebase from 'firebase'
import {fb} from './firebaseconfig'
let db = fb.database();


const remoteConfig = fb.remoteConfig();
  remoteConfig.settings = {
    minimumFetchIntervalMillis: 3000,
    // minimumFetchIntervalMillis: 3600000,
  };

  remoteConfig.ensureInitialized().then(() => {
  })
  .catch((err) => {
    console.error('Firebase Remote Config failed to initialize', err);
  });

  // remoteConfig.fetchAndActivate()
  // .then((activated) => {
  //   if (!activated) console.log('Fetched data not activated');
  //   console.log('Fetched data activated');
  //   this.country = remoteConfig.getValue('country')._value
  //   console.log('remoteConfig', this.country)
  // })
  // .catch((err) => {
  //   console.error('Error fetching and activating data', err);
  // });
  import IconCloud from './iconCloud.vue';

export default {
  components: {
    IconCloud
  },
  name: 'SlinkView',
  metaInfo () {
      return {
        script: [
        ],
        // noscript: [
        //   { innerHTML: this.fbPixelNoScript }
        // ]
        link: [
        ]
      }
    },
  data: function() {
    return {
      logos: [
      'https://cdn.brandfetch.io/ido5G85nya/theme/light/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id-0D6OFrq/theme/dark/idGIofJnQn.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idS5WhqBbM/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idJFz6sAsl/w/400/h/400/theme/dark/icon.png?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id20mQyGeY/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idpKX136kp/w/2084/h/2084/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id4VHp4_C_/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idVfYwcuQz/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id3gkQXO6j/w/400/h/400/theme/dark/icon.jpeg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idfA0qI6In/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id2UDPob7G/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idM8Hlme1a/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/idncaAgFGT.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id68S6e-Gp/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idItVJklDc/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idGP0S1Jjj/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idAgPm7IvG/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id-Wd4a4TS/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/idcZxK_wH8/theme/light/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
      'https://cdn.brandfetch.io/id5o3EIREg/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    ],
      country: null,
      loginEmail: '',
      loginPassword: '',
      signupEmail: '',
      signupPassword: '',
      notification: '',
      images: [   // Add your image URLs here
        { src: 'https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/aokmusic_qj_8uWh2I.png' },
        { src: 'https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/emtfilms_C-1nJmS-Ra.png' },
        { src: 'https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/localhost_8080_thecleopatraway(iPhone%2012%20Pro)_QvMhTd4G9.png' },
        // Add more image URLs as needed
      ],
      isDev: (window.location.href.indexOf('slinkdev') != -1) || (window.location.href.indexOf('localhost') != -1) ? true : false,
    }
  },
  // async beforecreate(){
  //   this.getCountry()
  // },
  created: function(){
    // this.country = remoteConfig.getValue('country')._value
    // console.log('created', this.country)
    console.log('isDev', this.isDev)
    this.getCountry()

    
  },
  mounted: function(){
    console.log('check for affiliate', this.$route.params.affiliatecode)
    // console.log('getCountry', this.getCountry)
   

  },
  computed:{
   
  },
  methods: {
    async getCountry(){
      // console.log('getCountry')
      // this.country = await remoteConfig.getValue('country')._value
      // console.log(this.country, 'l')
      await remoteConfig.fetchAndActivate();
      const countryValue = await remoteConfig.getValue('country')._value;
      this.country = countryValue;
      // console.log('dirty bud buds', this.country, countryValue)
      return await this.country
      // return this.country !== 'IN' ? true : false
      // return remoteConfig.getValue('country')._value
    },
    // screenshotHeight: function(object){
    //   console.log('image width',  object, document.getElementById(object))
    // },
    forgotPassword(email) {
      console.log('forgotPassword', email)
      if(!email){
        this.showNotification('Please enter your email address');
      }
      else{
        var self = this; 
      Firebase.auth().sendPasswordResetEmail(email).then(function(){
        self.gGALog(email, "Login", "Password Reset Email");
        self.showNotification('Password reset email sent');
      }).catch(function(error){
        self.showNotification(error.message);
        self.gGALog(email, "Login", "Password Reset Email Failed");
      });

      }
      
    },
    // showNotification(message){
    //   this.notification = message;
    //   this.$refs.snackbar.open();
    // },
    openExternal(url){
      window.open(url, '_blank')
    },
    openDialog(ref) {
      console.log('country', this.country)
      this.gGALog('Home', 'CTA', ref)
      this.$refs[ref].open();
    },
    closeDialog(ref) {
      this.$refs[ref].close();
    },
    createNewUser(user) {
      // console.log('new user', user)
      var username = user.email.split("@",1)[0].replace(/[\W\\_]/g,'').toLowerCase()
      var url = user.email.split("@",1)[0].replace(/[\W\\_]/g,'').toLowerCase()
      if (user.displayName != null){
        username = user.displayName
      }
      var picture = ""
      if(user.photoURL != null){
        picture = user.photoURL
      }
      try {
        let stripeConnect = this.$route.params.affiliatecode ? "acct_" + this.$route.params.affiliatecode : null
        let referrer =  this.$route.query.utm_source ? this.$route.query.utm_source : null;
        let newUser = db.ref('users/' + user.uid + '/').update({
          autoBackground: true,
          name: username,
          altProfile: 0,
          ad:false,
          picture: picture,
          url: url,  
          account:0, 
          onboarding: true,
          email: user.email,
          bio:'Welcome to my Slink Page',
          ad:false,
          socialShare:false,
          referrer: referrer,
          pictureShape:'squircle',
          stripeConnect: stripeConnect
        })
        if(!fb.auth().currentUser.emailVerified){
          fb.auth().currentUser.sendEmailVerification()
        }
      }
      catch (e) {console.log(e)}
      db.ref("url/"+ user.uid).update({url: url})
      if(this.$route.query.utm_source){
        this.gGALog(user.uid, "SignUp Referral", this.$route.query.utm_source)
      }
    },
    loginByGoogle: function(){
      const provider = new Firebase.auth.GoogleAuthProvider()
      fb.auth().signInWithPopup(provider).then((result) => {
        let self = this;
        console.log('login with google', result.user.uid)
        db.ref("users/"+result.user.uid+"/url").once('value').then(function(snapshot){
          if (snapshot.val() === null) {
            self.createNewUser(result.user)
            self.gGALog(result.user.uid, "SignUp", "SignUp Google")
          }
        })
        this.$router.replace({name:'Admin'});
        this.user = result.user
        this.gGALog(result.user.uid, "Login", "Login Google")
      }).catch(err => {
        this.showNotification(err.message);

        console.log(err)
      })

      // self.showNotification(error.message);
    },
    loginByEmail: function() {
      fb.auth().signInWithEmailAndPassword(this.loginEmail.toLowerCase().trim(), this.loginPassword).then(
        (user) => {
          // console.log('login with email', user.user.uid)
          this.gGALog(user.user.uid, "Login", "Login Email")
          this.$router.replace({name:'Admin'})
        },
        (err) => {
          this.gGALog(this.loginEmail, "Login Failed", err.message)
          console.log('login error', err)
          if(err.message == 'The password is invalid or the user does not have a password.' && this.loginEmail.toLowerCase().indexOf != -1 ){
            this.showNotification("Incorrect password. If you registered with a Google account please try the 'Login with Google' option")
          }else if(err.code == "auth/user-not-found"){
              this.showNotification("Account not found, please check email and retry");
          }
          else{
            this.showNotification(err.message);
          }
        }
      );
    },
    signupByEmail: function() {
      
      fb.auth().createUserWithEmailAndPassword(this.signupEmail.toLowerCase().trim(), this.signupPassword).then((success) => {
        this.createNewUser(success.user)
        // console.log(success.user.uid)
        this.gGALog(success.user.uid, "SignUp", "SignUp Email")
      }).catch((err) => {
        if(err.message.includes("Failed to execute")){
          
        }
        // console.log(err);
        // this.error = err;
        this.showNotification(err.message);
          this.gGALog(this.signupEmail, "Signup Failed", err.message)

      })
    }
  }
}
</script>
<style>

.phone{
  aspect-ratio:1080/1920; 
  width: 150px; 
  border-radius: 10px; 
  padding: 7px; 
  /* box-shadow: 0 50px 100px -20px rgb(50 50 93 / 25%), 0 30px 60px -30px rgb(0 0 0 / 30%), inset 0 -2px 6px 0 rgb(10 37 64 / 35%);  */
  box-shadow: 0 5px 10px -2px rgb(50 50 93 / 25%), 0 3px 6px -1px rgb(0 0 0 / 30%), inset 0 -2px 6px 0 rgb(10 37 64 / 35%);
  background: #f6f9fc;
  overflow: hidden;
}

.slider .phone img{
  aspect-ratio: 1080/1920;
  border-radius:5px;
  width:100%;
  max-height: 95%;
  object-position: top;
  border:1px solid silver;
}

.slider {
    width: 100vw;
    margin: auto;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
}
.slider ul {
    display: inline-block;
    white-space: nowrap;
    padding: 0;
    animation: infinislide 15s infinite linear;
}
.slider li {
    padding:0 10px;
    list-style: none;
}
.slider img {
    /* max-width: fit-content !important; */
    max-width:150px;
    width:150px;
    aspect-ratio:1/1;
    object-fit:cover;
    object-position: center;
    height: auto !important;
}
@keyframes infinislide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}





</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.toolbarButtons{
  font-weight:bold;
  margin-right: 0px;
  padding-left: 12px;
  padding-right: 12px;
}

.signupBtn{
  border-radius:10px;
  width:calc(160px + 5vw);
  margin-left:auto;
  margin-right:auto;
  margin-top:20px
}



.fling-minislide {
  width:100%; 
  aspect-ratio: 3/6;
  min-height:330px; 
  /* height:50vh;  */
  overflow:hidden; 
  position:relative; 
  border-radius: 15px;
  border: 1px solid silver;
  
}
.fling-minislide img{ 
  position:absolute; 
  animation:fling-minislide 30s infinite; 
  opacity:0; 
  left:0px; 
  min-height: 250px;
  border-radius: 15px;
  /* aspect-ratio:1080/1920 */
}

@keyframes fling-minislide {25%{opacity:1;} 40%{opacity:0;}} 
.fling-minislide img:nth-child(6){animation-delay:0s;}
.fling-minislide img:nth-child(5){animation-delay:5s;}
.fling-minislide img:nth-child(4){animation-delay:10s;}
.fling-minislide img:nth-child(3){animation-delay:15s;}
.fling-minislide img:nth-child(2){animation-delay:20s;}
.fling-minislide img:nth-child(1){animation-delay:25s;}


#home{
  text-align: center;
}

#toolbar{
    /* position:sticky; */
    /* top:0px; */
    /* z-index:100; */
    position: sticky;
    width: calc(100% - 20px);
    top: 10px;
    z-index: 100;
    align-self: center;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 20%) 0px 1px 5px, rgb(0 0 0 / 14%) 0px 2px 2px, rgb(0 0 0 / 12%) 0px 3px 1px -2px;
    background-color: #f5f5f5e0; 
}

section{
  padding-bottom:30px;
}

h2{
  text-transform:uppercase;
  margin-left:5vw;
  margin-right:5vw;
  font-size: 2.5em;
  font-weight:900;
  line-height: 1.1; 
}

.happySlinkersUL {
  text-align: left;
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.googleBtn {
  width:100%;
  border-radius:5px;
  margin:unset
  /* margin-bottom:10px; */

}

.testimonials{
  background:whitesmoke;
      min-height: 100px;
    width: 100%;
    margin:10px;
    padding:5px;
    display: -webkit-inline-box;
    overflow-y: hidden;
    overflow-x:scroll;
    gap: 15px; 
    scrollbar-width: thin;
} 

.testimonials::-webkit-scrollbar {
  margin-top:5px;
  height:5px;
  width:80%
}

::-webkit-scrollbar-track {
  background: red;
  margin-top:5px;
  width:80%
}

.testimonials::-webkit-scrollbar-thumb {
  margin-top:5px;
  padding:5px;
    background-color: rgba(0, 0, 0, .3); /* Or any other instruction making the element visible */
}

.testimonials,.md-board .testimonial{
  box-shadow:0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
  border-radius: 15px;
  overflow:hidden;
  /* border: 1px solid black; */
  /* gap:10px; */
  display: flex;
  width:100%
}

.testimonials,.md-board .testimonial img{
    aspect-ratio: 5/6;
    width: 100px;
    object-fit: cover;
    object-position: center;
}

.testimonials,.md-board .testimonial .content{
  padding:10px;
  width:100%;
  text-align: left;
  /* aspect-ratio: 1/1; */
    /* width: 40%; */
    /* object-fit: cover; */
}

.testimonials,.md-board .testimonial .content .review{
  height:calc(100% - 20px);
}

.testimonials,.md-board .testimonial .content .name{
  font-weight: bold;
}

.productsContainer{
  display: flex;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
  max-width: 475px;
  margin-left:auto;
  margin-right:auto
}

.productsContainer .product{
  color:black;
  width:100%;
  overflow: hidden;
  border-radius:15px; 
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 5px, rgb(0 0 0 / 14%) 0px 2px 2px, rgb(0 0 0 / 12%) 0px 3px 1px -2px;
}
.productsContainer .product figure{
  margin:unset
}
.productsContainer .product figure img{
  margin:unset;
  aspect-ratio: 4/3; 
  object-fit: cover;
  object-position: center; 
}

.productsContainer .product figcaption{
  margin:5px
}

.md-snackbar .md-button:last-child{
  margin:unset
}


</style>


// WEBPACK FOOTER //
// src/components/home.vue